'use client'

import React from 'react';
import { StyledPlatofrmsHero } from './platformsHero.styles';
import { Header } from '../header/header.comp';

export const PlatformsHero = () => {
    return (
        <StyledPlatofrmsHero>
            <Header/> 
            <div className="hero-wrapper">
                <h1>Common Ninja’s Widgets+ Work on Any Website and E-commerce Store</h1>
                <h2>Our widgets+ can be easily embedded on any website, blog, e-commerce platform, or website builder.</h2>
            </div>
        </StyledPlatofrmsHero>
    );
};
